$(document).ready(function () {
  $('.bundle-product').click(function () {
    $(this).parents('.bundle-products').find('.bundle-product').removeClass('selected-product');
    $(this).parents('.bundle-selection-products').find('.ProductSubmitButtonBundlePrice').text($(this).data('price'));
    $(this).addClass('selected-product');
    var selectedVariant=$(this).find('.selectedProductVariant').val();
  });
  $('.variant-options input').change(function() {
    var variantOptions = $(this).parents('.bundle-product').find('.variant-selection-bundle');
    var variantIds = $(this).parents('.bundle-product').find('.hidden-variants');
    var mainID = $(this).parents('.bundle-product').find('.selectedProductVariant');
    var checkedInputs = variantOptions.find('input:checked');
    var selectedVariants = checkedInputs.map(function() {
      return $(this).val();
    }).get();
    var concatenatedVariants = selectedVariants.join('/');
    var handleizedString = concatenatedVariants
      .toLowerCase()                         // Convert to lowercase
      .replace(/[^\w\s\/]/g, '')            // Remove special characters except spaces and slashes
      .replace(/\s+/g, '-')                 // Replace spaces with hyphens
      .replace(/\//g, '-');
    variantID = variantIds.find('.'+handleizedString).val();
    mainID.val(variantID);    
  });
  $('.ProductSubmitButtonBundle').click(function(e) {
    e.preventDefault(); 
    
    var id = $(this).parents('.bundle-selection-products').find('.selected-product').find('.selectedProductVariant').val();
    
    if (!id) {
      alert('No variant selected!');
      return;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        console.log('Cart cleared successfully');
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: id,
            quantity: 1
          },
          dataType: 'json',
          success: function(data) {
            console.log('Item added to cart:', data);
            window.location.href = '/checkout';
          },
          error: function(xhr, status, error) {
            console.error('Error adding item to cart:', error);
            alert('Could not add item to cart: ' + xhr.responseJSON.description);
          }
        });
      },
      error: function(xhr, status, error) {
        console.error('Error clearing cart:', error);
        alert('Could not clear cart: ' + xhr.responseJSON.description);
      }
    });
  });
});


// Smooth scrolling for hash links
document.addEventListener('DOMContentLoaded', () => {
  // Select all links with hash (#) in the href attribute
  const hashLinks = document.querySelectorAll('a[href^="#"]');
  
  // Add click event listener to each hash link
  hashLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Prevent default anchor click behavior
      e.preventDefault();
      
      // Get the target element id from the hash link
      const targetId = this.getAttribute('href');
      
      // Return early if the hash is just "#" (top of page)
      if (targetId === '#') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        return;
      }
      
      // Get the target element by id
      const targetElement = document.querySelector(targetId);
      
      // If target element exists, scroll to it smoothly
      if (targetElement) {
        // Get the position of the target element relative to the viewport
        const rect = targetElement.getBoundingClientRect();
        
        // Calculate the absolute position by adding the current scroll position
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetPosition = rect.top + scrollTop;
        
        // Scroll to the target element with smooth behavior
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        
        // Update the URL hash (optional)
        history.pushState(null, null, targetId);
      }
    });
  });
});